import React from "react";
import upIcon from '../../icons/up.svg';
import downIcon from '../../icons/down.svg';
import upIconWhite from '../../icons/upWhite.svg';
import downIconWhite from '../../icons/downWhite.svg';

const ExpandArrow = (props) => {
    var up = props.white ? upIconWhite : upIcon;
    var down = props.white ? downIconWhite : downIcon;
    return (
        <img alt='' className={'icon expandArrow ' + (props.className ? props.className : '')} src={props.isExpanded ? up : down} onClick={() => props.onToggleExpanded(!props.isExpanded)}></img>
    );
};

export default ExpandArrow;